// extracted by mini-css-extract-plugin
export var columnItem = "_3g-3";
export var columnItemDraggable = "_3g-4";
export var dragHandle = "_3g-0";
export var dragHandleHovered = "_3g-1";
export var dropdown = "_3g-5";
export var dropdownContent = "_3g-7";
export var dropdownInner = "_3g-6";
export var filterDropdownHeader = "_3g-8";
export var icon = "_3g-2";
export var sectionDivider = "_3g-9";